// Components
import FilterModule from "../../components/Campaigns/FilterModuleStatic"

function LeftSideContainer() {
  return (
    <div className="flex flex-col">
      <FilterModule />
    </div>
  )
}

export default LeftSideContainer
